import { PAYROLL_STATUS_LABELS, PAYROLL_STEPS, PayrollStatus, payrollStatusTone, payrollStepsDone } from "@viewModels";

interface Props {
  status: PayrollStatus;
  // Compact: dots + current status for table cells. Full: labelled steps for the details page.
  compact?: boolean;
}

// Shows where a payroll is in the approval chain.
const PayrollStageTracker = ({ status, compact }: Props) => {
  const done = payrollStepsDone(status);
  const returned = status === PayrollStatus.ReturnedToHR;

  const stepState = (index: number) => {
    if (returned && index === 0) return "is-returned";
    if (index < done) return "is-done";
    if (index === done) return "is-current";
    return "";
  };

  if (compact) {
    return (
      <div className="stage-compact" title={PAYROLL_STEPS.map((s, i) => `${i < done ? "✓" : "○"} ${s.role}`).join("\n")}>
        <div className="stage-dots">
          {PAYROLL_STEPS.map((s, i) => (
            <span key={s.status} className={`stage-dot ${stepState(i)}`} />
          ))}
        </div>
        <span className={`stage-label tone-${payrollStatusTone(status)}`}>{PAYROLL_STATUS_LABELS[status] ?? status}</span>
      </div>
    );
  }

  return (
    <ol className="stage-tracker">
      {PAYROLL_STEPS.map((s, i) => (
        <li key={s.status} className={`stage-step ${stepState(i)}`}>
          <span className="stage-marker">{i < done ? <i className="fa fa-check" /> : i + 1}</span>
          <span className="stage-text">
            <strong>{returned && i === 0 ? "Returned" : s.title}</strong>
            <small>{s.role}</small>
          </span>
        </li>
      ))}
    </ol>
  );
};

export default PayrollStageTracker;
